import React, { Component } from "react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import isEqual from 'lodash.isequal';
import omit from 'lodash.omit';
import functions from 'lodash.functions';
//import FlexView from "react-flexview";
import PropTypes from "prop-types";
import { getLocaleText, getPinnedBottom, initializePinnedBottom, getSiNoFilterComponent, getEstadoFilterComponent, getMostrarOcultarFilterComponent, getSubirBajarFilterComponent, getOtroFormatoFilterComponent, getTipoValorFilterComponent } from "./functions";

import "./styles.scss";
class DataGrid extends Component {
  constructor(props) {
    super(props);
  
    this.state = {
      numRows: 0,
      headers: this.props.columnDefs.map((c) => {
        return c.headerName;
      }),
      columns: [],
      scroll: 0,
      pinnedBottom: initializePinnedBottom(props.columnDefs, props.pinnedBottomRowData),
    };

    this.onGridReady = this.onGridReady.bind(this);
    this.onCellContextMenu = this.onCellContextMenu.bind(this);
    this.onRowDataChanged = this.onRowDataChanged.bind(this);
    this.onRowValueChanged = this.onRowValueChanged.bind(this);
    this.onCellValueChanged = this.onCellValueChanged.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onRowClicked = this.onRowClicked.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.onContextMenuItemClicked = this.onContextMenuItemClicked.bind(this);
    this.navigateToNextCell = this.navigateToNextCell.bind(this);
    this.onModelUpdatedEvent = this.onModelUpdatedEvent.bind(this);
    this.onFilterChanged = this.onFilterChanged.bind(this);
    this.onBodyScroll = this.onBodyScroll.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState){
    let isEqualProps = isEqual(
        JSON.stringify(omit(omit(this.props, functions(this.props)), 'selAll')), 
        JSON.stringify(omit(omit(nextProps, functions(nextProps)), 'selAll'))
    );
    let isEqualState = isEqual(
        JSON.stringify(omit(omit(this.state, functions(this.state)), 'selAll')), 
        JSON.stringify(omit(omit(nextState, functions(nextState)), 'selAll'))
    );
    

    console.log('shouldComponentUpdate_Grid', !isEqualProps || !isEqualState)
    return !isEqualProps || !isEqualState;
    }

  componentDidUpdate(prevProps) {
    this.props.updateApi && this.props.updateApi(this.api)
  }

  render() {
    return (
      <div ref={React.createRef()} className={"ag-theme-alpine customGrid "}>
        {this.renderStructureGrid(this.props)}
        {this.renderTotalRows()}
      </div>
    );
  }

  autoSizeAll() {
    var allColumnIds = [];
    this.columnApi.getAllColumns().forEach(function (column) {
      allColumnIds.push(column.colId);
    });
    this.columnApi.autoSizeColumns(allColumnIds);
  }

  navigateToNextCell(params) {
    var previousCell = params.previousCellDef;
    var suggestedNextCell = params.nextCellDef;

    var KEY_UP = 38;
    var KEY_DOWN = 40;
    var KEY_LEFT = 37;
    var KEY_RIGHT = 39;

    switch (params.key) {
      case KEY_DOWN:
        previousCell = params.previousCellDef;
        // set selected cell on current cell + 1
        this.api.deselectAll();
        this.api.forEachNode((node) => {
          if (previousCell.rowIndex + 1 === node.rowIndex) {
            node.setSelected(true);
          }
        });
        return suggestedNextCell;
      case KEY_UP:
        previousCell = params.previousCellDef;
        // set selected cell on current cell - 1
        this.api.deselectAll();
        this.api.forEachNode((node) => {
          if (previousCell.rowIndex - 1 === node.rowIndex) {
            node.setSelected(true);
          }
        });
        return suggestedNextCell;
      case KEY_LEFT:
      case KEY_RIGHT:
        return suggestedNextCell;
      default:
        throw "this will never happen, navigation is always on of the 4 keys above";
    }
  }

  onBodyScroll(event) {
    if (event.direction === "horizontal" && this.state.scroll < event.left) {
      if (this.props.autoSize) this.autoSizeAll();

      this.setState({
        scroll: event.left,
      });
    }
  }

  onModelUpdatedEvent() {
    if (this.props.preselectedall) {
      this.api.selectAll();
    }
    this.setState({ numRows: this.api.getDisplayedRowCount(),
    pinnedBottom: getPinnedBottom(this.props.columnDefs,this.api.getModel().rowsToDisplay)});
    
    if (this.props.autoSize) this.autoSizeAll();
  }
  onGridReady(params) {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.autoSizeAll();
    this.setState({
      pinnedBottom: getPinnedBottom(
        this.props.columnDefs,
        this.api.getModel().rowsToDisplay,
        this.props.pinnedBottomRowData
      ),
      numRows: this.api.getModel().rootNode.childrenAfterFilter.length,
    });
  }

  onCellValueChanged(event) {
    if (this.props.onCellValueChanged && event.newValue !== event.oldValue) {
      this.props.onCellValueChanged(this.api, event);
    }
  }

  onCellContextMenu(event) {
    if (this.props.contextMenu) {
      event.event.preventDefault();
      this.refs.grid.api.deselectAll();
      event.node.setSelected(true);

      this.props.showMenu(this.props.contextMenu, {
        open: true,
        event: event.event,
        onMenuClick: this.onContextMenuItemClicked,
      });
    }
  }

  onSelectionChanged(event) {
    if (this.props.onSelectionChanged && (this.api.getSelectedRows().length || this.props.norowsevent)) {
      this.props.onSelectionChanged(this.api, this.api.getSelectedRows());
    }
  }

  onRowDataChanged(event) {
    if (this.props.onRowDataChanged) {
      this.props.onRowDataChanged(this.api, event);
    }
  }

  onRowValueChanged(event) {
    if (this.props.onRowValueChanged) {
      this.props.onRowValueChanged(this.api, event);
    }
  }

  onRowClicked(event) {
    if (this.props.onRowClicked) {
      this.props.onRowClicked(this.api, event);
    }
  }

  onRowSelected(event) {
    if (this.props.onRowSelected) {
      this.props.onRowSelected(this.api);
      //this.onSelectionChanged(event);
    }
  }

  onContextMenuItemClicked(opcion) {
    if (this.onContextMenuItemClicked) {
      let eventArgs = {
        opcion: opcion,
        data: this.refs.grid.api.getSelectedRows(),
      };

      this.props.onContextMenuItemClicked(this.api, eventArgs);
    }
  }

  onDragStopped(event, fn) {
    if (fn)
      this.setState({
        columns: fn(this.columnApi.getColumnState()),
      });
  }

  renderTotalRows() {
    return (
      <div  className="bottom-container">
        <div className="label-rows">
          Total de Registros:
          {this.state.numRows}
        </div>
      </div>
    );
  }

  renderStructureGrid(props) {
    return (
      // <div  className="ag-theme-balham" style={this.props.style}>
        // <div ref={React.createRef()} className={"ag-theme-balham customGrid "}>
          <AgGridReact
            ref="grid"
            rowData={this.props.data}
            columnDefs={this.props.columnDefs}
            enableColResize={this.props.enableColResize}
            enableSorting={this.props.enableSorting}
            editType={this.props.editType}
            rowHeight={this.props.rowHeight}
            rowDeselection={this.props.rowDeselection}
            rowSelection={this.props.rowSelection}
            getRowStyle={this.props.rowStyle}
            floatingFilter={this.props.floatingFilter}
            floatingBottomRowData={this.props.floatingBottomRowData}
            suppressRowClickSelection={this.props.suppressRowClickSelection}
            onGridReady={this.onGridReady}
            onCellValueChanged={this.onCellValueChanged}
            onCellContextMenu={this.onCellContextMenu}
            onSelectionChanged={this.onSelectionChanged}
            onRowDataChanged={this.onRowDataChanged}
            onRowClicked={this.onRowClicked}
            onRowSelected={this.onRowSelected}
            onRowValueChanged={this.onRowValueChanged}
            onComponentStateChanged={this.onModelUpdatedEvent}
            //onViewportChanged={this.onViewportChanged}
            localeText={getLocaleText()}
            navigateToNextCell={this.navigateToNextCell}
            onFilterChanged={this.onFilterChanged}
            onBodyScroll={this.onBodyScroll}
            multiSortKey="ctrl"
            onDragStopped={this.onDragStopped}
            enableRangeSelection
            pinnedBottomRowData={this.state.pinnedBottom}
            components={{
              SiNoFilter : getSiNoFilterComponent(),
              EstadoFilter: getEstadoFilterComponent(),
              MostrarOcultarFilter: getMostrarOcultarFilterComponent(),
              SubirBajarFilter: getSubirBajarFilterComponent(),
              OtroFormatoFilter: getOtroFormatoFilterComponent(),
              TipoValorFilter: getTipoValorFilterComponent()
            }}
            
          />
        // </div>
      // </div>
    );
  }

  onFilterChanged(event) {
    this.setState({
      pinnedBottom: getPinnedBottom(this.props.columnDefs, this.api.getModel().rowsToDisplay),
      numRows: this.api.getModel().rootNode.childrenAfterFilter.length,
    });
  }
}

DataGrid.propTypes = {
  autofit: PropTypes.bool,
  autoSize: PropTypes.bool,
  columnDefs: PropTypes.array.isRequired,
  data: PropTypes.array,
  ref: PropTypes.any,
  contextMenu: PropTypes.string,

  editType: PropTypes.oneOf(["single", "fullRow"]),
  enableColResize: PropTypes.bool,
  enableFilter: PropTypes.bool,
  enableSorting: PropTypes.bool,
  floatingFilter: PropTypes.bool,
  floatingBottomRowData: PropTypes.array,
  rowHeight: PropTypes.number,
  rowSelection: PropTypes.oneOf(["single", "multiple"]),
  rowDeselection: PropTypes.bool, //If true then rows will be deselected if you hold down ctrl + click the row.
  suppressCellSelection: PropTypes.bool, //If true, cells won't be selectable. This means cells will not get keyboard focus when you click on them.
  suppressRowClickSelection: PropTypes.bool, //If true, row selection won't happen when rows are clicked. Use when you want checkbox selection exclusively.

  onCellValueChanged: PropTypes.func,
  onCellContextMenu: PropTypes.func,
  onSelectionChanged: PropTypes.func,
  onRowDataChanged: PropTypes.func,
  onRowValueChanged: PropTypes.func,
  onRowClicked: PropTypes.func,
  onRowSelected: PropTypes.func,
  onContextMenuItemClick: PropTypes.func,

  columnVisible: PropTypes.func,
  onClickColumn: PropTypes.func,

  preselectedall: PropTypes.bool,
  norowsevent: PropTypes.bool,

  style: PropTypes.object,

  columnsState: PropTypes.array,
  onHideColumn: PropTypes.func,
  menuContent: PropTypes.any,
  handleCreatePDF: PropTypes.func,
  pinnedBottomRowData: PropTypes.array,
  updateApi: PropTypes.func
};

DataGrid.defaultProps = {
  autofit: true,
  autoSize: true,
  data: [],
  ref: undefined,
  floatingBottomRowData: [],

  editType: "fullRow",
  enableColResize: true,
  enableFilter: true,
  enableSorting: true,
  rowHeight: 25,
  rowSelection: "multiple",
  rowDeselection: false,
  suppressCellSelection: false,
  suppressRowClickSelection: false,

  preselectedall: false,
  norowsevent: false,

  getRowStyle: "",
  floatingFilter: false,
  styles: { width: "100vw", padding: "0.5rem" },
  columnsState: [],
  onHideColumn: () => {},
};

export default DataGrid;
